export default __webpack_public_path__ + "static/media/05.db524cb6.jpg";